import { render, staticRenderFns } from "./TransferModal.vue?vue&type=template&id=8b3bd8f2&scoped=true"
import script from "./TransferModal.vue?vue&type=script&lang=js"
export * from "./TransferModal.vue?vue&type=script&lang=js"
import style0 from "./TransferModal.vue?vue&type=style&index=0&id=8b3bd8f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3bd8f2",
  null
  
)

export default component.exports